import { createContext, useCallback, useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { APP_NAME } from '../brand';

export const PageTitleContext = createContext<(title: string) => void>(() => {});

/** Заголовок страницы в верхней панели оболочки. */
export function usePageTitle(title: string) {
  const setTitle = useContext(PageTitleContext);
  useEffect(() => {
    setTitle(title);
    document.title = title ? `${title} — ${APP_NAME}` : APP_NAME;
  }, [title, setTitle]);
}

/** Карточка сотрудника открывается поверх любой страницы: ?person=<id> в адресе. */
export function usePersonDrawer() {
  const [params, setParams] = useSearchParams();
  const personId = params.get('person');
  const open = useCallback(
    (id: string) =>
      setParams((previous) => {
        const next = new URLSearchParams(previous);
        next.set('person', id);
        return next;
      }),
    [setParams],
  );
  const close = useCallback(
    () =>
      setParams((previous) => {
        const next = new URLSearchParams(previous);
        next.delete('person');
        return next;
      }),
    [setParams],
  );
  return { personId, open, close };
}
